import { mm, Viewer } from "@inovitas/infra3dsdk";
import { useEffect, useState } from "react";

export const UseActiveLayer = (viewer: Viewer | undefined) => {
  const [activeLayer, setActiveLayer] = useState<mm.Layer | null>(null);

  useEffect(() => {
    if (!viewer) {
      setActiveLayer(null);
      return;
    }

    const updateActiveLayer = () => {
      setActiveLayer(viewer.getScene().getLayerHandler().getActiveLayer());
    };

    viewer.on(Viewer.layerchanged, updateActiveLayer);

    updateActiveLayer();

    return () => {
      viewer.off(Viewer.layerchanged, updateActiveLayer);
    };
  }, [viewer]);

  return activeLayer;
};
